import React from 'react';
import { Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import css from './ForwardingAddressCard.module.scss';

const { Text } = Typography;

interface ForwardingAddressCardProps {
  address: string;
}

const ForwardingAddressCard: React.FC<ForwardingAddressCardProps> = ({ address }) => (
  <aside className={css.card} aria-labelledby="forwarding-address-heading">
    <div className={css.iconWrap} aria-hidden="true">
      <MailOutlined className={css.icon} />
    </div>
    <div className={css.body}>
      <h4 id="forwarding-address-heading" className={css.heading}>
        Forward replies to this application
      </h4>
      <div className={css.addressField}>
        <Text
          className={css.address}
          copyable={{
            text: address,
            tooltips: ['Copy address', 'Copied!'],
          }}
        >
          {address}
        </Text>
      </div>
      <p className={css.helper}>
        Replies sent here go straight to this application — no matching
        guesswork. Use it when subject lines or sender addresses might change.
      </p>
    </div>
  </aside>
);

export default ForwardingAddressCard;
